var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.ready
      ? _c("aside", { staticClass: "app-loading" }, [
          _c("p", [_vm._v("Loading Online Scheduling...")]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.ready
      ? _c("aside", { staticClass: "online-scheduling" }, [
          _vm.loading ? _c("div", { staticClass: "loading" }) : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content", class: { dimmed: _vm.loading } },
            [
              _c("div", { staticClass: "main" }, [
                _c("span", { staticClass: "title d-block text-center" }, [
                  _vm._v("Schedule an Appointment in "),
                  _c("strong", [_vm._v(_vm._s(_vm.clinic.name))]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-beltone lg mx-auto d-block my-3",
                    on: {
                      click: function ($event) {
                        return _vm.changeLocations()
                      },
                    },
                  },
                  [_vm._v("Change Locations")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "progress-status" }, [
                  _c(
                    "div",
                    { staticClass: "step", class: _vm.getStepState(1) },
                    [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          alt: "Step 1",
                          src: "images/step1-" + _vm.getStepState(1) + ".svg",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "header" }, [
                        _vm._v("Step 1"),
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "copy" }, [
                        _vm._v("Select Day & Time"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bar" }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "step", class: _vm.getStepState(2) },
                    [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          alt: "Step 2",
                          src: "images/step2-" + _vm.getStepState(2) + ".svg",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "header" }, [
                        _vm._v("Step 2"),
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "copy" }, [
                        _vm._v("Provide Information"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bar" }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "step", class: _vm.getStepState(3) },
                    [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          alt: "Step 3",
                          src: "images/step3-" + _vm.getStepState(3) + ".svg",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "header" }, [
                        _vm._v("Step 3"),
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "copy" }, [
                        _vm._v("Confirmation"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bar" }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.step === 1
                ? _c("step-1", { attrs: { clinicId: _vm.clinic.id } })
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 2 ? _c("step-2") : _vm._e(),
              _vm._v(" "),
              _vm.step === 3 ? _c("step-3") : _vm._e(),
              _vm._v(" "),
              _vm.step === 4 ? _c("step-4") : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }